export interface Article {
  id: string;
  title: string;
  excerpt: string;
  content: string;
  categorySlug: string;
  categoryName: string;
  author: string;
  publishedAt: string;
  readCount: number;
  commentCount: number;
  imageUrl: string;
  imagePrompt: string;
  tags: string[];
  isHot: boolean;
  isExclusive: boolean;
}

export const articles: Article[] = [
  {
    id: 'article-1',
    title: '某顶级流量明星私下人设崩塌，圈内人士曝出惊人内幕',
    excerpt: '据悉，该明星在公开场合塑造的完美形象与其私下行为大相径庭，多位圈内人士匿名爆料其真实面目令人震惊……',
    content: `<p>近日，一位不愿透露姓名的圈内资深人士向本平台独家爆料，某顶级流量明星在私下的行为与其精心打造的公众形象存在巨大反差。</p>
<p>据该人士透露，这位明星在镜头前展现出的温柔体贴、勤奋努力的形象，与其私下的傲慢无礼、耍大牌行为形成鲜明对比。多位曾与其合作的工作人员均表示，该艺人在片场经常迟到，对待工作人员态度恶劣。</p>
<p>"有人亲眼看到他在片场因为一件小事就对助理大发雷霆，甚至摔东西。"知情人士表示，"但在粉丝面前，他永远是那个微笑温暖的大男孩。"</p>
<p>更令人震惊的是，该艺人还被指在感情生活中存在不端行为。据爆料，他在与现任女友交往期间，多次被拍到与其他女性过从甚密。虽然经纪团队多次公关辟谣，但圈内对此早已心知肚明。</p>
<p>一位曾在某综艺节目与其共事的编导透露："他在镜头前后的反差太大了。录制一结束，脸上的笑容就立刻消失，对工作人员爱答不理。有时候节目组安排的环节不符合他的心意，就直接甩脸色。"</p>
<p>业内人士分析认为，随着社交媒体的发展，明星"人设"崩塌的事件越来越频繁。在信息高度透明的今天，任何虚假形象都难以长期维持。公众应该更加理性地看待明星，不要被精心包装的"人设"所迷惑。</p>
<p>本平台将持续关注此事进展，更多内幕敬请期待。</p>`,
    categorySlug: 'yule-baoliao',
    categoryName: '娱乐爆料',
    author: '91黑料调查组',
    publishedAt: '2026-08-04T14:30:00Z',
    readCount: 125800,
    commentCount: 3421,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20mysterious%20atmosphere%20with%20a%20silhouette%20of%20a%20person%20on%20stage%20under%20dramatic%20spotlight%2C%20contrasting%20shadows%2C%20cinematic%20photography%20style%2C%20film%20noir%20aesthetic%2C%20dark%20background%20with%20subtle%20red%20accents%2C%20moody%20and%20atmospheric%2C%20high%20contrast%20black%20and%20dark%20gray%20tones&width=800&height=500&seq=article-1&orientation=landscape',
    imagePrompt: 'Dark mysterious atmosphere with a silhouette of a person on stage under dramatic spotlight, contrasting shadows, cinematic photography style, film noir aesthetic, dark background with subtle red accents',
    tags: ['流量明星', '人设崩塌', '娱乐圈黑料', '明星私下'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-2',
    title: '某科技巨头内部邮件曝光：用户数据被暗中收集长达五年',
    excerpt: '一封泄露的内部邮件显示，该科技公司多年来在未经用户明确同意的情况下，大规模收集和分析用户隐私数据……',
    content: `<p>本平台独家获取了一封来自某知名科技巨头的内部邮件，邮件内容显示该公司在过去五年间，一直在未经用户明确授权的情况下，大规模收集和分析用户隐私数据。</p>
<p>这封邮件的发件人是该公司数据部门的一位高级经理，收件人包括多位副总裁级别的高管。邮件中详细描述了数据收集的范围、方式和用途，内容令人震惊。</p>
<p>"我们已经建立了一个覆盖超过2亿用户的行为数据库，"邮件中写道，"包括用户的浏览习惯、地理位置轨迹、社交关系网络、消费偏好等数十个维度的数据。这些数据为我们的广告精准投放提供了巨大价值。"</p>
<p>更令人担忧的是，邮件中明确提到了"在用户协议中模糊化相关条款"的策略。该公司法务团队被指有意将数据收集条款隐藏在冗长的用户协议中，利用用户不愿阅读长篇协议的心理，规避法律风险。</p>
<p>隐私保护专家对此表示强烈谴责。一位不愿透露姓名的数据安全专家表示："这种行为严重侵犯了用户隐私权。根据相关法律法规，企业在收集用户个人数据前必须获得明确同意，而非通过模糊条款蒙混过关。"</p>
<p>目前，该科技公司尚未对此事作出正式回应。据悉，相关监管部门已经注意到这一情况，或将展开调查。</p>
<p>本平台将继续跟踪报道此事的最新进展。</p>`,
    categorySlug: 'keji-heiliao',
    categoryName: '科技黑料',
    author: '91黑料科技组',
    publishedAt: '2026-08-04T10:15:00Z',
    readCount: 98700,
    commentCount: 2856,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20server%20room%20with%20blinking%20red%20lights%2C%20data%20center%20aesthetic%2C%20ominous%20mood%2C%20cybersecurity%20theme%2C%20dark%20background%20with%20digital%20interfaces%2C%20moody%20cinematic%20lighting%2C%20tech%20noir%20style&width=800&height=500&seq=article-2&orientation=landscape',
    imagePrompt: 'Dark server room with blinking red lights, data center aesthetic, ominous mood, cybersecurity theme, dark background with digital interfaces',
    tags: ['科技巨头', '数据隐私', '内部邮件', '用户数据'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-3',
    title: '某知名企业财务造假曝光：通过空壳公司转移资产数十亿',
    excerpt: '深度调查发现，某知名上市公司通过复杂的关联交易和空壳公司网络，多年来持续进行财务造假，涉及金额巨大……',
    content: `<p>经过长达三个月的深度调查，本平台发现了某知名上市公司进行大规模财务造假的惊人事实。该公司通过精心设计的关联交易网络和数十家空壳公司，多年来持续虚增收入和转移资产。</p>
<p>调查显示，该公司在海外设立了多家空壳公司，通过这些公司与上市公司进行虚假交易，将上市公司的资金转移到境外账户。整个过程设计精巧，涉及多个国家和地区的金融机构，使得监管部门的追踪异常困难。</p>
<p>"他们的操作手法非常专业，"一位参与调查的财务专家表示，"利用离岸公司的复杂结构，配合虚假的贸易合同和物流单据，整套流程看起来天衣无缝。要不是有一个环节出现了纰漏，可能永远都不会被发现。"</p>
<p>据估算，通过这一套操作，该公司在过去五年间至少有超过30亿元人民币的资金被非法转移。而这些资金的最终去向，目前仍然是一个谜。</p>
<p>更为严重的是，该公司在财务报告中虚增了大量收入。通过虚构销售合同和循环交易，公司在账面上呈现出持续高速增长的态势，从而维持股价和吸引投资者。</p>
<p>目前，该公司的股票已在交易所停牌。有消息称，证监会已经介入调查，多位高管被限制出境。</p>
<p>本平台将持续关注调查进展，为读者带来最新报道。</p>`,
    categorySlug: 'caijing-jiemi',
    categoryName: '财经揭秘',
    author: '91黑料财经组',
    publishedAt: '2026-08-03T16:45:00Z',
    readCount: 76500,
    commentCount: 1987,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20corporate%20office%20with%20scattered%20documents%20and%20financial%20papers%2C%20ominous%20atmosphere%2C%20dramatic%20shadows%2C%20business%20conspiracy%20theme%2C%20film%20noir%20style%20photography%2C%20dark%20moody%20lighting%20with%20subtle%20warm%20tones&width=800&height=500&seq=article-3&orientation=landscape',
    imagePrompt: 'Dark corporate office with scattered documents and financial papers, ominous atmosphere, dramatic shadows, business conspiracy theme',
    tags: ['财务造假', '上市公司', '空壳公司', '资产转移'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-4',
    title: '网红直播带货惊天骗局：粉丝下单后收到的竟是空包裹',
    excerpt: '多位消费者向本平台投诉，在某知名网红直播间购买的商品，收到的是空包裹或劣质替代品，涉及金额巨大……',
    content: `<p>近期，本平台接到大量消费者投诉，称在某拥有千万粉丝的网红直播间购买商品后，收到的不是直播中展示的精美产品，而是空包裹或完全不同的劣质商品。</p>
<p>据投诉者王女士描述，她在该网红的直播间花费299元购买了一款"限量版精华液"，但收到的包裹中只有一个空的包装盒。"我打开包裹的时候简直不敢相信自己的眼睛，"王女士愤怒地说，"盒子里什么都没有，只有一张写着'谢谢支持'的小卡片。"</p>
<p>类似的情况并非个例。经统计，已有超过500名消费者遭遇类似情况，涉及金额超过50万元。而这些消费者在向平台投诉后，往往得到的只是"正在核实"的回复，退款遥遥无期。</p>
<p>更令人震惊的是，有证据表明这并非一时失误，而是一场有组织的骗局。一位自称是该网红前团队成员的人士爆料称，该团队专门设立了一个"清库存"项目，将有瑕疵甚至空的产品打包发货，利用直播间的巨大流量"快速收割"。</p>
<p>"他们算过了，即使有10%的人投诉要求退款，剩下的90%不会计较或者懒得计较，利润依然非常可观。"该前员工透露，"老板说过一句话：'韭菜割完一茬还有一茬，怕什么？'"</p>
<p>目前，多地市场监管部门已经介入调查。据悉，该网红已被多个平台限制直播功能。</p>
<p>本平台提醒广大消费者，在直播间购物时务必保持理性，注意保留购买凭证，遇到问题及时向有关部门投诉。</p>`,
    categorySlug: 'wanghong-bagua',
    categoryName: '网红八卦',
    author: '91黑料消费组',
    publishedAt: '2026-08-03T09:20:00Z',
    readCount: 156200,
    commentCount: 5678,
    imageUrl: 'https://readdy.ai/api/search-image?query=Pile%20of%20empty%20cardboard%20boxes%20and%20packages%20in%20a%20dark%20warehouse%2C%20dramatic%20lighting%2C%20consumer%20deception%20theme%2C%20dark%20moody%20atmosphere%2C%20cinematic%20photography%2C%20warm%20amber%20accents%20in%20shadows&width=800&height=500&seq=article-4&orientation=landscape',
    imagePrompt: 'Pile of empty cardboard boxes and packages in a dark warehouse, dramatic lighting, consumer deception theme, dark moody atmosphere',
    tags: ['直播带货', '消费骗局', '网红翻车', '空包裹'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-5',
    title: '某地方政府工程招标黑幕：内定中标企业暗藏利益输送',
    excerpt: '一份内部文件揭露了某地重大工程项目招标过程中的暗箱操作，多家企业被提前内定，涉及金额惊人……',
    content: `<p>本平台近日获得了一份标注为"内部机密"的文件，该文件详细记录了某地方政府一项重大工程的招标内幕，揭示了一场精心策划的利益输送链条。</p>
<p>该工程项目总投资额高达15亿元，涉及城市基础设施建设。按照正常流程，项目应该通过公开招标选出最佳承建方。然而，内部文件显示，在招标公告发布之前，中标企业就已经被内定。</p>
<p>文件详细列出了"会审意见"，对参与投标的十余家企业进行了评分。评分标准并非基于企业实力和报价，而是按照"与项目主管部门的关系密切程度"进行排序。最终中标的是一家成立不到三年的公司，其注册资本仅为项目总投资的十分之一。</p>
<p>"这是一场彻头彻尾的'围标'，"一位熟悉内情的工程行业人士对此表示，"其他参与投标的企业实际上都是'陪跑'的，他们拿到的是一份已经被内定了结果的招标文件。"</p>
<p>调查还发现，该中标公司的实控人与项目审批部门的某位领导存在密切的亲属关系。而在项目获批后不久，该领导的子女即收到了该公司一笔数额不菲的"咨询费"。</p>
<p>目前，相关情况已被反映至上级纪检部门。有消息称，专案组已经成立，正在对涉事人员进行调查。</p>
<p>本平台将继续关注此事的调查进展。</p>`,
    categorySlug: 'zhengshang-miwen',
    categoryName: '政商秘闻',
    author: '91黑料调查组',
    publishedAt: '2026-08-02T11:30:00Z',
    readCount: 89100,
    commentCount: 3245,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20government%20building%20silhouette%20at%20night%20with%20dramatic%20shadows%2C%20construction%20site%20in%20background%2C%20corruption%20theme%2C%20cinematic%20noir%20style%2C%20moody%20atmosphere%20with%20subtle%20red%20accents%2C%20dark%20and%20ominous&width=800&height=500&seq=article-5&orientation=landscape',
    imagePrompt: 'Dark government building silhouette at night with dramatic shadows, construction site in background, corruption theme, cinematic noir style',
    tags: ['招投标黑幕', '利益输送', '政府工程', '暗箱操作'],
    isHot: false,
    isExclusive: true,
  },
  {
    id: 'article-6',
    title: '娱乐圈新晋小花被曝学历造假，名校光环背后的真相',
    excerpt: '近期蹿红的某女演员被质疑学历造假，其声称的海外名校学历经查证并不存在，经纪公司紧急公关……',
    content: `<p>近期凭借一部热播剧迅速走红的新晋女演员林某某，被网友扒出其学历存在重大疑点。其团队宣传的"海外名校硕士"身份，经多方查证后暴露出诸多漏洞。</p>
<p>该演员在公开资料中声称毕业于美国某知名大学，获得传媒学硕士学位。然而，有网友在该校校友数据库中进行了查询，并未找到与之匹配的记录。进一步的调查发现，该校该专业该年份的毕业生名单中也不存在此人。</p>
<p>"我在那个学校读了四年本科加两年研究生，从来没有听说过这个人，"一位自称是该学校中国学生会的负责人表示，"而且她所说的专业在那个年份根本没有开设。"</p>
<p>面对质疑，该演员的经纪公司发布了一份含糊其辞的声明，称"艺人确实有过海外学习经历，由于年代久远，部分信息可能存在偏差"。但声明中没有提供任何实质性的证明材料。</p>
<p>娱乐圈学历造假并非新鲜事。近年来，已有多位艺人被曝光学历造假，有的甚至从未上过大学却声称自己拥有名校学位。业内人士指出，这种现象的根源在于市场对"学霸人设"的过度追捧。</p>
<p>"观众喜欢'学霸'，所以经纪公司就给艺人包装'学霸'，"一位娱乐圈资深经纪人坦言，"其实行业内很多人都知道哪些是真的哪些是假的，但大家心照不宣，没人戳破这层窗户纸。"</p>
<p>随着事态发酵，多个品牌方已经开始缩减与该演员的合作，原定的一部新剧也可能面临换角。</p>`,
    categorySlug: 'yule-baoliao',
    categoryName: '娱乐爆料',
    author: '91黑料娱乐组',
    publishedAt: '2026-08-02T08:00:00Z',
    readCount: 142300,
    commentCount: 4521,
    imageUrl: 'https://readdy.ai/api/search-image?query=Graduation%20cap%20and%20diploma%20in%20dramatic%20shadow%2C%20dark%20mysterious%20background%2C%20academic%20fraud%20theme%2C%20cinematic%20lighting%20with%20warm%20and%20cool%20contrast%2C%20moody%20atmosphere%2C%20film%20noir%20style&width=800&height=500&seq=article-6&orientation=landscape',
    imagePrompt: 'Graduation cap and diploma in dramatic shadow, dark mysterious background, academic fraud theme, cinematic lighting',
    tags: ['学历造假', '女演员', '人设崩塌', '娱乐圈黑料'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-7',
    title: '某社交App被曝窃听用户通话，精准推送广告背后的秘密',
    excerpt: '多名用户反映在私人通话中讨论的商品，随后在App中收到精准广告推送，引发对该App窃听功能的强烈质疑……',
    content: `<p>近期，大量用户在社交媒体上反映了一个令人不安的现象：他们在私人通话中讨论了某个商品或话题，随后在使用某社交App时就收到了与之高度相关的精准广告推送。</p>
<p>"我和朋友在电话里聊了要买一台空气炸锅，挂了电话打开这个App，首页推荐就是空气炸锅的广告，"用户张先生描述道，"这绝对不是巧合，因为我从来没有在这个App或者任何购物网站上搜索过空气炸锅。"</p>
<p>类似的经历在网络上引发了广泛共鸣。在#App窃听#话题下，已有超过20万条讨论。用户们分享了各种匪夷所思的"巧合"：有人通话中提到要去日本旅游，随后收到日本机票的广告；有人在电话中讨论给孩子报编程班，App立刻推送了编程培训广告。</p>
<p>对此，该App的运营方发表声明，坚决否认存在窃听行为，称"所有广告推送均基于用户授权收集的数据和算法推荐，绝不存在窃听用户通话的情况"。</p>
<p>然而，信息安全专家的看法却并不乐观。一位资深安全研究员表示："从技术角度来说，App在获得麦克风权限的情况下，完全有可能在后台进行语音识别。虽然各大应用商店都有隐私审核机制，但技术上绕过这些审核并非不可能。"</p>
<p>该专家建议用户在使用社交App时，注意检查应用权限设置，关闭不必要的麦克风、摄像头等权限。同时呼吁监管部门加强对App隐私安全的监管力度。</p>
<p>本平台提醒广大用户，保护个人隐私从管理App权限开始。</p>`,
    categorySlug: 'keji-heiliao',
    categoryName: '科技黑料',
    author: '91黑料科技组',
    publishedAt: '2026-08-01T15:40:00Z',
    readCount: 210500,
    commentCount: 7890,
    imageUrl: 'https://readdy.ai/api/search-image?query=Smartphone%20with%20red%20warning%20glow%20and%20sound%20wave%20visualization%2C%20dark%20background%2C%20privacy%20invasion%20theme%2C%20cybersecurity%20aesthetic%2C%20cinematic%20moody%20lighting%2C%20tech%20noir%20style&width=800&height=500&seq=article-7&orientation=landscape',
    imagePrompt: 'Smartphone with red warning glow and sound wave visualization, dark background, privacy invasion theme, cybersecurity aesthetic',
    tags: ['App窃听', '隐私安全', '精准广告', '麦克风权限'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-8',
    title: '某食品企业使用过期原料被内部员工举报，生产车间触目惊心',
    excerpt: '一位良心发现的内部员工向本平台举报，某知名食品企业长期使用过期原料生产食品，车间卫生状况令人担忧……',
    content: `<p>本平台近日接到一位自称是某知名食品企业前员工的实名举报，对方提供了大量照片和视频证据，揭露了该企业生产过程中的严重违规行为。</p>
<p>根据举报人提供的资料，该企业的生产车间存在多方面的问题。首先是原料管理混乱，大量已经过期的原料被继续使用。举报人提供的照片显示，多批标注保质期为2025年的原料，在2026年仍在正常使用。</p>
<p>"仓库里堆满了过期的面粉、油脂和添加剂，"举报人在视频中说道，"主管让我们把生产日期标签撕掉，重新贴上新的日期标签，这样就能'合法'地继续使用了。"</p>
<p>其次是车间卫生状况堪忧。照片显示，生产线上积有厚厚的污垢，设备长期未进行彻底清洁。地面上随意堆放着原料袋和半成品，老鼠和蟑螂的痕迹清晰可见。</p>
<p>"有一次，一只老鼠跑进了搅拌机，"举报人描述了一个令人作呕的场景，"但主管只是让人把老鼠捞出来，机器根本没有停下来清洗，继续生产。"</p>
<p>更令人愤怒的是，该企业还专门制定了一套应对外部检查的预案。据举报人透露，每当有监管部门来检查时，工厂会提前一天进行全面"大扫除"，将违规原料转移，恢复正常生产标准。检查一过，一切照旧。</p>
<p>目前，相关证据已提交给市场监管部门。据悉，执法人员已经对该企业进行了突击检查，部分生产线已被责令停产整顿。</p>
<p>本平台将持续关注此事的处理结果。</p>`,
    categorySlug: 'shehui-neimu',
    categoryName: '社会内幕',
    author: '91黑料调查组',
    publishedAt: '2026-08-01T12:00:00Z',
    readCount: 178900,
    commentCount: 6234,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20dirty%20food%20factory%20interior%20with%20dim%20lighting%2C%20industrial%20machinery%2C%20unsanitary%20conditions%2C%20ominous%20atmosphere%2C%20documentary%20style%20photography%2C%20dark%20moody%20tones%20with%20industrial%20aesthetic&width=800&height=500&seq=article-8&orientation=landscape',
    imagePrompt: 'Dark dirty food factory interior with dim lighting, industrial machinery, unsanitary conditions, ominous atmosphere',
    tags: ['食品安全', '过期原料', '内部举报', '卫生问题'],
    isHot: true,
    isExclusive: true,
  },
  {
    id: 'article-9',
    title: '某投资平台疑似庞氏骗局：用户资金无法提现，创始人失联',
    excerpt: '大量用户反映在某投资平台的资金无法提现，客服电话无人接听，公司办公地点人去楼空，疑似大规模跑路……',
    content: `<p>近日，本平台接到大量用户投诉，称在某知名投资理财平台上投入的资金无法提现。该平台此前以"高收益、低风险"为卖点吸引了大量用户，如今疑似整个平台已经爆雷。</p>
<p>据用户王先生描述，他在该平台累计投入了50万元。"一开始收益确实很高，年化收益率能达到15%到20%，而且随时可以提现。我就放松了警惕，陆续把家里的积蓄都投了进去。"然而，从上个月开始，平台突然宣布"系统升级"，暂停所有提现功能。</p>
<p>"客服一开始说'3个工作日内恢复'，后来变成'7个工作日'，再后来直接联系不上了，"王先生无奈地说，"我去他们公司所在地一看，大门紧锁，里面已经搬空了。"</p>
<p>经调查，该平台的运营模式存在典型的庞氏骗局特征：用新用户的资金支付老用户的收益，一旦新用户增长速度放缓，整个资金链就会断裂。多位金融专家分析认为，该平台涉及的资金总额可能超过100亿元。</p>
<p>更为严重的是，该平台在宣传中大量使用"银行存管""国资背景"等虚假信息。经核实，所谓的"银行存管"只是一份普通的支付合作协议，而"国资背景"更是子虚乌有。</p>
<p>目前，多地公安机关已对此立案侦查。但据知情人士透露，该平台创始人已经在爆雷前一周出境，目前下落不明。</p>
<p>本平台提醒广大投资者：理财有风险，投资需谨慎。切勿轻信高收益承诺。</p>`,
    categorySlug: 'caijing-jiemi',
    categoryName: '财经揭秘',
    author: '91黑料财经组',
    publishedAt: '2026-07-31T14:20:00Z',
    readCount: 203400,
    commentCount: 8901,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20empty%20office%20with%20abandoned%20desks%20and%20scattered%20papers%2C%20ominous%20atmosphere%2C%20financial%20scam%20theme%2C%20film%20noir%20style%2C%20moody%20lighting%2C%20dark%20shadows%20with%20subtle%20warm%20accents&width=800&height=500&seq=article-9&orientation=landscape',
    imagePrompt: 'Dark empty office with abandoned desks and scattered papers, ominous atmosphere, financial scam theme, film noir style',
    tags: ['庞氏骗局', '投资平台', '资金跑路', '金融诈骗'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-10',
    title: '某知名综艺节目内定冠军内幕曝光：评委收钱操控比赛结果',
    excerpt: '一位参加过该综艺的选手匿名爆料，节目中的比赛结果早已内定，评委私下收受选手经纪公司的贿赂……',
    content: `<p>在选秀综艺热度不减的当下，一份来自节目内部人员的爆料让观众大跌眼镜。一位自称参加过某知名音乐选秀节目的选手，公开揭露了节目中令人震惊的暗箱操作。</p>
<p>"我在参加节目前，经纪人就明确告诉我，'你这个名次是买不到的，因为前几名已经被更大的公司预定了'，"该选手在匿名采访中回忆道，"当时我不信，觉得凭实力比赛，但后来发现他说的全是真的。"</p>
<p>据爆料，该节目的冠亚季军早在海选阶段就已经基本确定。背后是各大经纪公司之间的"资源置换"——经纪公司通过向节目组和评委输送利益，换取旗下艺人在节目中获得更好的名次。</p>
<p>"一位评委的'合作费'在七位数，"知情人士透露，"不同名次对应不同的价码。冠军是最贵的，但回报也是最大的。冠军选手后续的商演、代言、综艺资源加起来，经纪公司轻松回本。"</p>
<p>该选手还描述了比赛中的一些具体操作手法："编导会在彩排的时候刻意调整某些选手的走位、灯光、音响效果。轮到'内定选手'的时候，所有条件都是最优的；轮到我们这些'陪跑选手'的时候，就会出现各种'意外状况'。"</p>
<p>此外，评委在点评环节也会配合"表演"——对内定选手大加赞赏，对普通选手即便表现不错也会挑出各种"问题"，从而影响观众投票的倾向。</p>
<p>消息一出，网友纷纷呼吁有关部门对选秀节目的评审机制进行规范和监管。目前，该节目组和涉及的评委尚未对此作出回应。</p>`,
    categorySlug: 'yule-baoliao',
    categoryName: '娱乐爆料',
    author: '91黑料娱乐组',
    publishedAt: '2026-07-31T10:00:00Z',
    readCount: 167800,
    commentCount: 5432,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dark%20stage%20with%20single%20spotlight%20and%20microphone%2C%20empty%20audience%20seats%2C%20dramatic%20shadows%2C%20behind%20the%20scenes%20of%20talent%20show%2C%20cinematic%20noir%20style%2C%20moody%20atmosphere&width=800&height=500&seq=article-10&orientation=landscape',
    imagePrompt: 'Dark stage with single spotlight and microphone, empty audience seats, dramatic shadows, behind the scenes of talent show',
    tags: ['综艺黑幕', '内定冠军', '选秀节目', '评委受贿'],
    isHot: false,
    isExclusive: true,
  },
  {
    id: 'article-11',
    title: '某大型房企资金链断裂内幕：百亿债务黑洞背后的真相',
    excerpt: '曾经风光无限的某头部房地产企业被曝资金链已完全断裂，总负债超千亿，数千业主面临烂尾风险……',
    content: `<p>房地产行业的寒冬远未结束。本平台通过多方渠道获取的内部资料显示，某曾经的TOP10房企目前已经处于事实上的破产状态，其资金链完全断裂，总负债超过千亿元。</p>
<p>资料显示，该房企在过去几年的快速扩张中，大量使用高杠杆融资。在房地产市场下行后，销售回款急剧下降，而到期债务却像雪球一样越滚越大。截至2026年7月，该公司账面可用资金已不足支付未来三个月到期的债务利息。</p>
<p>"这完全是管理层盲目扩张的结果，"一位前财务部门员工透露，"当时老板的口号是'三年冲千亿'，不管什么项目都敢拿，不管多少钱都敢借。我们都觉得太冒险了，但没有人敢说真话。"</p>
<p>更令人揪心的是，该房企在全国多地有超过30个在建项目，涉及数万名业主。随着资金链断裂，这些项目目前已大面积停工。业主们不仅面临烂尾风险，还要继续偿还银行贷款。</p>
<p>在昆明的一个项目现场，业主李女士告诉本平台记者："我全家的积蓄都砸在这套房子上了，贷款每个月要还8000多。现在房子停工已经半年，开发商人去楼空，我们找谁说理去？"</p>
<p>据悉，当地政府已经介入成立了工作专班，试图推动项目复工。但在巨大的资金缺口面前，复工遥遥无期。</p>
<p>业内人士分析认为，该房企的爆雷只是行业问题的一个缩影。在房地产调控持续深入的大背景下，更多隐藏的雷可能还在后面。</p>`,
    categorySlug: 'caijing-jiemi',
    categoryName: '财经揭秘',
    author: '91黑料财经组',
    publishedAt: '2026-07-30T16:30:00Z',
    readCount: 112300,
    commentCount: 3456,
    imageUrl: 'https://readdy.ai/api/search-image?query=Abandoned%20construction%20site%20with%20unfinished%20building%20at%20sunset%2C%20dark%20dramatic%20sky%2C%20real%20estate%20crisis%20theme%2C%20cinematic%20photography%2C%20moody%20atmosphere%2C%20urban%20decay%20aesthetic&width=800&height=500&seq=article-11&orientation=landscape',
    imagePrompt: 'Abandoned construction site with unfinished building at sunset, dark dramatic sky, real estate crisis theme, cinematic photography',
    tags: ['房地产', '资金链断裂', '烂尾楼', '债务危机'],
    isHot: false,
    isExclusive: false,
  },
  {
    id: 'article-12',
    title: '顶流带货主播税务问题再升级：补税金额或达九位数',
    excerpt: '继多位头部主播被查税后，又一顶流主播被曝涉及严重税务问题。知情人士称其通过多种方式逃避个人所得税，补税金额惊人……',
    content: `<p>直播带货行业的税务风暴仍在持续。据知情人士透露，一位拥有超过5000万粉丝的顶流带货主播正面临严重的税务问题，需要补缴的税款和罚款总额可能达到九位数。</p>
<p>知情人士透露，税务部门在对该主播的调查中发现了多种逃税手段。包括但不限于：将个人直播收入转移至名下多家个体工商户，利用核定征收政策大幅降低税率；通过虚构成本、虚列支出等方式减少应纳税所得额；将部分收入以"咨询费""服务费"等名义转移至税收洼地。</p>
<p>"他们的操作手法非常专业，"一位税务人士表示，"背后有一整个团队在运作，包括会计师、律师和税务顾问。但他们还是低估了大数据查税的能力。"</p>
<p>据悉，税务部门通过金税系统的大数据分析，发现了该主播收入与纳税严重不匹配的异常情况。进一步调查后，大量逃税证据浮出水面。目前该主播团队正在与税务部门积极沟通，试图争取宽大处理。</p>
<p>事实上，这已不是该行业的首个案例。自2021年以来，已有多位头部主播因税务问题被查处，其中不乏被处以数亿元罚款的案例。业内人士认为，税务部门的监管力度只会越来越大。</p>
<p>"对于主播来说，合规纳税是必修课，"一位直播行业分析师表示，"那些还在用各种手段逃税的主播，迟早会被查到。到这个体量还想省钱，无异于自掘坟墓。"</p>
<p>目前，该主播的直播间已暂停直播，多个品牌方已暂停与其合作。本平台将持续关注此事的后续进展。</p>`,
    categorySlug: 'wanghong-bagua',
    categoryName: '网红八卦',
    author: '91黑料消费组',
    publishedAt: '2026-07-30T09:00:00Z',
    readCount: 189500,
    commentCount: 6789,
    imageUrl: 'https://readdy.ai/api/search-image?query=Money%20and%20tax%20documents%20on%20a%20dark%20desk%20with%20dramatic%20lighting%2C%20financial%20investigation%20theme%2C%20dark%20moody%20atmosphere%2C%20cinematic%20noir%20style%2C%20warm%20and%20cool%20contrast&width=800&height=500&seq=article-12&orientation=landscape',
    imagePrompt: 'Money and tax documents on a dark desk with dramatic lighting, financial investigation theme, dark moody atmosphere',
    tags: ['主播', '税务问题', '逃税', '直播带货'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-13',
    title: '某外卖平台算法压榨骑手内幕：为抢时间不惜闯红灯',
    excerpt: '内部数据显示某外卖平台的算法系统不断压缩骑手配送时间，导致骑手不得不超速、闯红灯才能完成订单……',
    content: `<p>外卖骑手的生存状况再次引发关注。本平台获取的某头部外卖平台内部数据显示，该平台的AI算法系统通过不断缩短配送时间，变相逼迫骑手冒险违规行驶，以完成日益严苛的配送指标。</p>
<p>数据显示，在过去两年中，该平台的平均配送时间要求从45分钟压缩至28分钟，降幅接近40%。而与此同时，骑手的配送范围却在扩大，交通状况并未改善。这意味着骑手必须在更短的时间内完成更远距离的配送。</p>
<p>"以前一个小时送3单，现在要送5单甚至6单，"在平台跑了三年外卖的老张说，"不闯红灯根本来不及。我们都想遵守交通规则，但如果超时了，一单扣5块钱，一天的辛苦就白费了。"</p>
<p>更为严重的是，平台的算法会自动学习最快配送路径，并将其设为新的标准线。也就是说，如果有骑手冒险超速或闯红灯提前送达，算法就会认为"这条路线可以更快"，于是下一次就会给所有骑手设定更短的时间。</p>
<p>"这本质上是在让骑手之间互相'内卷'，"一位研究平台经济的学者分析道，"算法把个别人的极限行为当作所有人的标准要求，这种机制完全违背了劳动保护的基本原则。"</p>
<p>据交警部门统计，与外卖骑手相关的交通事故数量在过去两年增长了超过60%。多位受伤的骑手反映，平台的保险赔付流程极为繁琐，很多情况下需要自己垫付大笔医药费。</p>
<p>本平台呼吁有关部门加强对平台算法的监管，切实保障骑手的劳动安全和合法权益。</p>`,
    categorySlug: 'shehui-neimu',
    categoryName: '社会内幕',
    author: '91黑料调查组',
    publishedAt: '2026-07-29T13:15:00Z',
    readCount: 231600,
    commentCount: 8901,
    imageUrl: 'https://readdy.ai/api/search-image?query=Delivery%20rider%20on%20scooter%20in%20rain%20at%20night%2C%20urban%20street%20with%20neon%20lights%2C%20dark%20moody%20atmosphere%2C%20gig%20economy%20struggle%20theme%2C%20cinematic%20photography%2C%20rainy%20and%20dramatic&width=800&height=500&seq=article-13&orientation=landscape',
    imagePrompt: 'Delivery rider on scooter in rain at night, urban street with neon lights, dark moody atmosphere, gig economy struggle theme',
    tags: ['外卖平台', '算法压榨', '骑手安全', '劳动权益'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-14',
    title: '某知名导演被曝潜规则女演员，多名受害者勇敢发声',
    excerpt: '十余名女演员联合发声，指控某知名导演在片场和选角过程中多次实施不当行为，行业整顿呼声高涨……',
    content: `<p>娱乐圈的#MeToo运动仍在持续发酵。近日，十余名女演员通过本平台联合发声，公开指控某知名导演在多年的从业生涯中多次利用职权实施不当行为。</p>
<p>据受害者们描述，该导演的惯用手法是在选角面试时，以"试戏"为名要求女演员进行各种不当接触。有受害者回忆说："他让我一个人去酒店房间试戏，说是为了'更准确地评估表演潜力'。我刚进门他就反锁了房门……"</p>
<p>另一位化名小A的女演员表示，她在拒绝了导演的不当要求后，原本已经确定的角色被临时更换。"副导演私下跟我说，'这个圈子就是这样，你要懂规矩'。那一刻我心都凉了。"</p>
<p>据多位业内人士透露，该导演的行为在圈内早已是公开的秘密，但由于其地位和资源，多年来无人敢于公开揭露。直到近期，随着越来越多的受害者站出来，这段黑暗历史才逐渐浮出水面。</p>
<p>"我们等了太久了，"受害者之一的演员小C说，"每一次看到他在颁奖典礼上满口仁义道德，我都感到恶心。今天我们终于站出来了，不是为了一己私利，而是为了后来者不再遭受同样的伤害。"</p>
<p>事件曝光后，多家影视公司和播出平台已经宣布终止与该导演的合作。业内呼吁建立更加完善的行业规范和举报机制，保护从业者的合法权益。</p>
<p>据悉，相关行业协会已启动调查程序。本平台将持续关注调查进展。</p>`,
    categorySlug: 'yule-baoliao',
    categoryName: '娱乐爆料',
    author: '91黑料娱乐组',
    publishedAt: '2026-07-29T08:45:00Z',
    readCount: 256700,
    commentCount: 10234,
    imageUrl: 'https://readdy.ai/api/search-image?query=Empty%20director%20chair%20on%20dark%20stage%20with%20single%20spotlight%2C%20dramatic%20shadows%2C%20me%20too%20movement%20theme%2C%20powerful%20yet%20dark%20cinematic%20photography%2C%20moody%20atmosphere&width=800&height=500&seq=article-14&orientation=landscape',
    imagePrompt: 'Empty director chair on dark stage with single spotlight, dramatic shadows, me too movement theme, powerful yet dark cinematic photography',
    tags: ['导演', '潜规则', '女演员', 'MeToo'],
    isHot: true,
    isExclusive: false,
  },
  {
    id: 'article-15',
    title: '某二手车平台调表车当准新车卖，鉴定报告系伪造',
    excerpt: '消费者投诉在某知名二手车平台购买的"准新车"实际为调表车，平台提供的鉴定报告完全伪造，里程数被大幅调低……',
    content: `<p>"花12万买了一辆表显2万公里的'准新车'，去4S店一查，实际里程已经超过8万公里。"消费者刘先生向本平台投诉，自己在某知名二手车平台遭遇了调表车欺诈。</p>
<p>刘先生介绍，他是在该平台App上看到这辆标价为12.8万元的二手轿车。平台页面显示该车为"准新车"，上牌仅一年，表显里程2.1万公里，并且附有平台的"官方检测认证报告"。</p>
<p>"我就是看中了那个认证报告才决定买的，"刘先生说，"上面盖着平台的章，写着'经专业检测，里程数据真实有效'。我想着这么大的平台不至于骗人。结果呢？全是假的。"</p>
<p>提车后，刘先生在4S店做保养时，技师在系统中查到了该车之前的维修记录。记录显示，该车在去年8月的一次保养中，里程数就已达7.6万公里。也就是说，该车至少被调低了5.5万公里的里程。</p>
<p>刘先生立即联系平台要求退车赔偿，但平台的回应令人失望。"客服说他们只提供'撮合服务'，不能保证车辆信息的真实性，让我直接找卖家解决。而卖家电话已经打不通了。"</p>
<p>经调查，该平台所谓的"认证报告"并非由独立第三方出具，而是平台内部自行"检测"的。业内人士透露，很多平台为了促成交易、赚取服务费，对于调表等问题往往睁一只眼闭一只眼。</p>
<p>目前，刘先生已向市场监管部门和消协投诉。本平台提醒消费者，购买二手车务必通过正规渠道查询车辆维保记录，不要轻信平台的"检测报告"。</p>`,
    categorySlug: 'shehui-neimu',
    categoryName: '社会内幕',
    author: '91黑料消费组',
    publishedAt: '2026-07-28T15:00:00Z',
    readCount: 98700,
    commentCount: 3245,
    imageUrl: 'https://readdy.ai/api/search-image?query=Used%20car%20with%20odometer%20in%20dark%20showroom%2C%20dramatic%20lighting%2C%20fraud%20theme%2C%20cinematic%20noir%20style%2C%20moody%20atmosphere%2C%20dark%20shadows%20with%20subtle%20warm%20highlights&width=800&height=500&seq=article-15&orientation=landscape',
    imagePrompt: 'Used car with odometer in dark showroom, dramatic lighting, fraud theme, cinematic noir style',
    tags: ['二手车', '调表车', '消费欺诈', '平台责任'],
    isHot: false,
    isExclusive: true,
  },
  {
    id: 'article-16',
    title: '某游戏公司内部贪腐案：高管挪用资金超五千万用于境外赌博',
    excerpt: '知名游戏公司高管被曝利用职务之便挪用公司资金用于境外赌博，公司内部审计发现后已报案处理……',
    content: `<p>游戏行业再爆贪腐大案。据可靠消息，某知名游戏公司的副总裁级别高管因涉嫌挪用公司资金被公安机关立案侦查，涉案金额超过5000万元。</p>
<p>据悉，该高管负责公司的市场推广业务，手中有审批大额营销预算的权限。调查发现，其在过去两年中，通过与多家"关系户"广告代理商签订远高于市场价的虚假合同，将差价部分截留并转移到个人控制的境外账户。</p>
<p>"他会要求供应商报价时虚报30%到50%，成交后让供应商把差价返还到指定账户，"一位了解内情的公司员工透露，"这些钱最终都流向了澳门和新加坡的赌场。"</p>
<p>据调查，该高管是澳门赌场的常客，几乎每个月都会飞往澳门赌博。其赌资从最初的几万元一路"升级"到数百万元一局。为了填补日益增长的赌博亏空，其挪用的金额也越来越大。</p>
<p>该公司在最近的一次内部审计中发现了异常。多笔大额营销费用的回报率明显偏低，进一步追查后发现合同和资金流动存在重大问题。公司随即向公安机关报案。</p>
<p>"这种事情在游戏行业并不罕见，"一位游戏行业从业者表示，"游戏公司现金流大，营销预算高，如果内控不严，很容易出现监守自盗的问题。区别只在于有没有被发现。"</p>
<p>目前，该高管已被警方控制，案件正在进一步侦办中。本平台将继续关注案件进展。</p>`,
    categorySlug: 'keji-heiliao',
    categoryName: '科技黑料',
    author: '91黑料科技组',
    publishedAt: '2026-07-28T10:30:00Z',
    readCount: 134500,
    commentCount: 4567,
    imageUrl: 'https://readdy.ai/api/search-image?query=Poker%20chips%20and%20gaming%20documents%20on%20dark%20table%2C%20corporate%20corruption%20theme%2C%20dramatic%20cinematic%20lighting%2C%20dark%20moody%20atmosphere%2C%20film%20noir%20style&width=800&height=500&seq=article-16&orientation=landscape',
    imagePrompt: 'Poker chips and gaming documents on dark table, corporate corruption theme, dramatic cinematic lighting',
    tags: ['游戏公司', '高管贪腐', '挪用资金', '境外赌博'],
    isHot: false,
    isExclusive: true,
  },
];